(function () {
  const titleCache = new Map();

  function youtubeWatchUrl(videoId) {
    return `https://www.youtube.com/watch?v=${videoId}`;
  }

  function buildEmbedUrl(videoId, autoplay) {
    const params = new URLSearchParams({ rel: '0' });

    if (autoplay) {
      params.set('autoplay', '1');
      params.set('playsinline', '1');
    }

    return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`;
  }

  function loadMainVideo(playerContainer, videoId, options = {}) {
    const { autoplay = false, title = 'YouTube video' } = options;
    const currentId = playerContainer.dataset.videoId;

    if (currentId === videoId && playerContainer.querySelector('.meta-videos__iframe')) {
      return;
    }

    const oldIframe = playerContainer.querySelector('.meta-videos__iframe');
    if (oldIframe) {
      oldIframe.remove();
    }

    const iframe = document.createElement('iframe');
    iframe.className = 'meta-videos__iframe';
    iframe.dataset.videoId = videoId;
    iframe.title = title;
    iframe.width = '800';
    iframe.height = '450';
    iframe.src = buildEmbedUrl(videoId, autoplay);
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('allowfullscreen', '');
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');

    playerContainer.appendChild(iframe);
    playerContainer.dataset.videoId = videoId;
  }

  async function fetchYoutubeTitle(videoId) {
    if (titleCache.has(videoId)) {
      return titleCache.get(videoId);
    }

    const watchUrl = youtubeWatchUrl(videoId);

    try {
      const response = await fetch(
        `https://www.youtube.com/oembed?url=${encodeURIComponent(watchUrl)}&format=json`
      );

      if (response.ok) {
        const data = await response.json();
        const title = data.title?.trim() || '';
        titleCache.set(videoId, title);
        return title;
      }
    } catch (error) {
      // Fall through to noembed.
    }

    try {
      const response = await fetch(
        `https://noembed.com/embed?url=${encodeURIComponent(watchUrl)}`
      );

      if (response.ok) {
        const data = await response.json();
        const title = data.title?.trim() || '';
        titleCache.set(videoId, title);
        return title;
      }
    } catch (error) {
      // Ignore and use fallback below.
    }

    titleCache.set(videoId, '');
    return '';
  }

  function applyVideoTitle(section, videoId, title) {
    const resolvedTitle = title || 'YouTube video';
    const playerContainer = section.querySelector('[data-meta-videos-player]');
    const iframe = playerContainer?.querySelector('.meta-videos__iframe');

    if (iframe?.dataset.videoId === videoId) {
      iframe.title = resolvedTitle;
    }

    section.querySelectorAll(`[data-meta-videos-item][data-video-id="${videoId}"]`).forEach((button) => {
      if (button.dataset.videoTitle && button.dataset.videoTitle !== 'YouTube video') {
        return;
      }

      button.dataset.videoTitle = resolvedTitle;
      button.setAttribute('aria-label', resolvedTitle);

      const titleEl = button.querySelector('[data-meta-videos-title]');
      if (titleEl && !titleEl.textContent.trim()) {
        titleEl.textContent = resolvedTitle;
      }
    });
  }

  function loadTitles(section) {
    const videoIds = new Set();
    const playerContainer = section.querySelector('[data-meta-videos-player]');

    if (playerContainer?.dataset.videoId) {
      videoIds.add(playerContainer.dataset.videoId);
    }

    section.querySelectorAll('[data-meta-videos-item][data-video-id]').forEach((button) => {
      const presetTitle = button.dataset.videoTitle?.trim();
      const titleEl = button.querySelector('[data-meta-videos-title]');

      if (presetTitle && presetTitle !== 'YouTube video') {
        if (titleEl && !titleEl.textContent.trim()) {
          titleEl.textContent = presetTitle;
        }
        return;
      }

      if (button.dataset.videoId) {
        videoIds.add(button.dataset.videoId);
      }
    });

    Array.from(videoIds).forEach((videoId) => {
      fetchYoutubeTitle(videoId).then((title) => {
        applyVideoTitle(section, videoId, title);
      });
    });
  }

  function initSection(section) {
    const playerContainer = section.querySelector('[data-meta-videos-player]');
    const items = section.querySelectorAll('[data-meta-videos-item]');

    if (!playerContainer) return;

    loadTitles(section);

    items.forEach((button) => {
      button.addEventListener('click', () => {
        const videoId = button.dataset.videoId;
        const videoTitle = button.dataset.videoTitle || 'YouTube video';

        if (!videoId) return;

        loadMainVideo(playerContainer, videoId, {
          autoplay: true,
          title: videoTitle
        });

        items.forEach((item) => {
          item.classList.toggle('is-active', item === button);
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('.meta-videos').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
